<template>
    <div class="uk-padding-large ">
        <div class="uk-container">
            <h2 class="uk-text-bold uk-text-center">Donate to the RESCUE 2020</h2>
            <div class="uk-text-center">
                <router-link to="/rescuedonate" class="uk-button uk-button-default uk-text-capitalize " style="background: rgb(3, 56, 96); color: gold">Support the Initiative</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "rescueCall"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h3{
            font-size: 1.2em !important;
        }
        h2{
            font-size: 1.3em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
